import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol viewBox=\"0 0 14 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-comment\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.80295 11.8167H4.57488V14.2215L7.74681 11.8167H11.003C12.3284 11.8167 13.403 10.7399 13.403 9.41165V3.79984C13.403 2.4716 12.3284 1.39484 11.003 1.39484H3.80295C2.47747 1.39484 1.40295 2.4716 1.40295 3.79984V9.41165C1.40295 10.7399 2.47747 11.8167 3.80295 11.8167Z\" stroke=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol